module.exports = __webpack_public_path__ + "media/images/refresh-e45f5253657fc3987a1e640f77f62c72.svg";